<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
@if (contentData && !contentData.hidden && contentData.text) {
  <div
    id="global-announcement-banner-container"
    class="global-announcement-banner"
    (mouseenter)="isHovering = true"
    (mouseleave)="isHovering = false"
  >
    <span class="global-announcement-banner-content">
      <a
        [routerLink]="contentData.link"
        [ngStyle]="{
          color: isHovering ? contentData.hovertextcolor : contentData.textColor
        }"
        [innerHTML]="contentData.text"
      >
      </a>
    </span>
  </div>
}
